export default __webpack_public_path__ + "static/media/dna.57fcc948.jpg";